import { Icon, Toast } from '@revolut-internal/ui-kit'

export const CopyToClipboardErrorToast = () => {
  return (
    <Toast>
      <Toast.Indicator>
        <Icon name="Cross" size={20} />
      </Toast.Indicator>
      <Toast.Label>Failed to copy to clipboard</Toast.Label>
    </Toast>
  )
}
